<template>
  <router-view />
</template>

<script>
import user from "@/api/user";

export default {
  name: "App",
  async mounted() {
    if (this.$cookies.isKey("refresh_token")) {
      await user.refresh();
      const { data } = await user.getLoginStatus();
      this.$store.commit("setUser", data);
      setInterval(async () => {
        await user.refresh();
      }, 840000);
    }
    window.addEventListener("resize", this.setScreenSize);
    this.setScreenSize();
  },
  unmounted() {
    window.removeEventListener("resize", this.setScreenSize);
  },
  methods: {
    setScreenSize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
  },
  watch: {
    $route() {
      if (this.$store.state.menuOpen) {
        this.$store.commit("setMenuOpen", false);
      }
    },
  },
};
</script>
